module.exports = __webpack_public_path__ + "img/bitrue-desktop.e8cf7915.png";